import { apiPaths } from 'app/services/api';
import React from 'react';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';
import { MOBILE_REGEX } from 'app/views/smart-kit/Form/gridFormUtils';
import { provinces } from '../agents/AgentForm';

export const storeFields = [
  { label: 'Store Name', key: 'name', validation: { required: true } },
  { label: 'Shop Id', key: 'shop_id', validation: { required: false } },
  { label: 'Address', key: 'address', validation: { required: true } },
  {
    label: 'City',
    key: 'city',
    validation: { required: true },
    type: 'select',
    items: provinces.map((province) => ({
      value: province.slug,
      label: province.name,
    })),
  },
  { label: 'Email', key: 'email', validation: { required: false } },
  {
    label: 'Phone Number',
    key: 'phone_number',
    validation: { required: true },
    placeholder: '...0912',
  },
  { label: 'Website', key: 'website', validation: { required: false } },
  // { label: 'Account Number', key: 'account_number', validation: { required: false } },
  { label: 'Sheba Number', key: 'iban', validation: { required: true }, prefix: 'IR-' },
  { label: 'Sheba Verified', key: 'iban_verified', type: 'checkbox', auth: 'admin' },

  { label: 'Account Holder', key: 'account_holder', validation: { required: true } },
  {
    label: 'Contract Image',
    key: 'contract_pic',
    type: 'image',
    purpose: 'contract_pic',
    validation: { required: true },
  },
  {
    label: 'Contract Image Back',
    key: 'contract_pic_back',
    type: 'image',
    purpose: 'contract_pic_back',
    validation: { required: true },
  },
  {
    label: 'Location',
    key: 'location',
    type: 'location',
    validation: { required: false },
  },
  // { label: 'City', key: 'city', validation: { required: false } }

  // {label: 'Type', key: 'type', type: 'select', items: [{value: 'govermental', label: 'Govermental'}, {value: 'private', label: 'Private'},
  // {value: 'semiprivate', label: 'Semiprivate'}, {value: 'knowledge_enterprise', label: 'Knowledge Enterprise'},], validation: {required: false}},

  // {label: 'Industry', key: 'industry', validation: {required: false}},
  { isTab: true, mod: 'add', tabs: ['Store Manager'] },
  // {label: 'Requested Package Count', key: 'requested_package_count', tab: 0, type: 'number', validation: {required: false}},
  // {label: 'Pickedup Package Name', key: 'pickedup_package_name', tab: 0, validation: {required: false}},

  {
    tab: 0,
    mod: 'add',
    validation: { required: true },
    label: 'Store Manager Name',
    group: 'Name',
    groupIndex: 0,
    key: 'store_manager.name',
  },
  {
    tab: 0,
    mod: 'add',
    validation: { required: true },
    label: 'Store Manager Last Name',
    group: 'Name',
    groupIndex: 1,
    key: 'store_manager.last_name',
  },
  {
    tab: 0,
    mod: 'add',

    label: 'Store Manager Mobile',
    key: 'store_manager.mobile_number',
    validation: {
      required: true,
      pattern: { value: MOBILE_REGEX, message: 'not a valid mobile' },
    },
  },

  // {tab: 1, label: 'HR Name', key: 'hr_name'},
  // {tab: 1, label: 'HR Last Name', key: 'hr_last_name'},
  // {tab: 1, label: 'HR Mobile', key: 'hr_mobile_number'},
];
const StoreForm = () => {
  return (
    <CrudGridForm path={apiPaths.STORES} name="Store" entityName={'stores'} fields={storeFields} />
  );
};

export default StoreForm;
